<template>
  <div class="notebook-container">
    <notebook-view
      :edit="false"
      :contentData="contentData"
    ></notebook-view>
  </div>
</template>
<script>
import notebookView from "@/components/notebook-view.vue";
export default {
  components: {
    notebookView,
  },
  data() {
    return {
      userId: 1,    //this.$route.params.userId,
      codeFileId: 0,
      contentData:{"cells":[{"metadata":{"trusted":true},"cell_type":"code","source":"print(1 + 2)","execution_count":null,"outputs":[{"output_type":"stream","text":"3","name":"stdout"}]}],"metadata":{"language_info":{"name":"python","version":"3.8.1","mimetype":"text/x-python","pygments_lexer":"ipython3","nbconvert_exporter":"python","file_extension":".py","codemirror_mode":{"name":"ipython","version":3}},"kernelspec":{"name":"python3","display_name":"Python 3","language":"python"}},"nbformat":4,"nbformat_minor":2,"dxfiles":[]},
     
    };
  },
};
</script>
<style lang="less" scoped>
  .notebook-container {
    position: relative;
    width: 1000px;
    height: 500px;;
  }

</style>
